// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"275":"e0431a03","560":"4a6a339d","596":"62c5ada1","598":"823cd1d0","689":"e660d9f0","732":"4e8c499f","764":"433f84f2","830":"4ab9f56d","855":"0b1bb537"}[chunkId] + ".chunk.js";
};